import { addDays, format, parseISO } from 'date-fns';

// Policies store endDate as the last day of coverage; the customer-facing
// expiration date is the policy anniversary, which is endDate + 1 day. The
// search results column was rendering the raw endDate, displaying a date one
// day before the actual expiration. (#31020)
export const formatEffectiveDateRange = ({ effectiveDate, endDate } = {}) => {
  if (!effectiveDate || !endDate) {
    return '';
  }
  const start = format(parseISO(effectiveDate), 'MM/dd/yyyy');
  const expiration = format(addDays(parseISO(endDate), 1), 'MM/dd/yyyy');
  return `${start} - ${expiration}`;
};
